export default __webpack_public_path__ + "static/media/football2.7d693014.svg";